import { createAction } from '@reduxjs/toolkit';

import { TrackingInfo } from '../../client';

export const fetchTracking = createAction<{ barcode: string }>('Load tracking list');
export const fetchTrackingSuccess = createAction<{ list: TrackingInfo[] }>('Load tracking list success');
